import { render, staticRenderFns } from "./CoreFooter.vue?vue&type=template&id=e39389de&scoped=true"
import script from "./CoreFooter.vue?vue&type=script&lang=js"
export * from "./CoreFooter.vue?vue&type=script&lang=js"
import style0 from "./CoreFooter.vue?vue&type=style&index=0&id=e39389de&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39389de",
  null
  
)

export default component.exports